import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import styles from "./TariffTile.scss";

const TariffTileListItemDescription = forwardRef(
  ({ children, ...restProps }, ref) => {
    return (
      <span ref={ref} className={styles.listItemDescription} {...restProps}>
        {children}
      </span>
    );
  }
);

TariffTileListItemDescription.displayName = "TariffTile.ListItemDescription";

TariffTileListItemDescription.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

TariffTileListItemDescription.defaultProps = {
  children: undefined,
};

export default TariffTileListItemDescription;
